import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import MyLists from '../views/MyLists.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: "Consultar lista - Listas de regalos online"
    },
    component: HomePage
  },
  {
    path: '/newlist',
    name: 'newlist',
    meta: {
      title: "Crear lista - Listas de regalos online"
    },
    component: () => import(/* webpackChunkName: "newlist" */ '../views/NewList.vue')
  },
  {
    path: '/faqs',
    name: 'faqs',
    meta: {
      title: "Preguntas frecuentes - Listas de regalos online",
    },
    component: () => import(/* webpackChunkName: "faqs" */ '../views/Faqs.vue')
  },
  {
    path: '/:id',
    name: 'viewlist',
    meta: {
      title: "Ver lista - Listas de regalos online"
    },
    component: MyLists
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Listas de regalos online"
  next()
})

export default router